/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { TFormContext } from '../types/internal';

export const initialValue: TFormContext = {
  quizStarted: false,
  quizCompleted: false,
  setPrevStep: () => null,
  startQuiz: () => null,
  setAnswersState: () => null,
  setAnswer: () => null,
  setNextStep: () => null,
  answersState: {} as any,
  currentQuestion: {} as any,
  maxStepsCount: 0,
  currentStepCount: 0,
  quizSubmitError: null,
  quizSubmitting: false,
  registerBackInterceptor: () => null,
  unRegisterBackInterceptor: () => null,
  handleCompleteQuiz: () => null as any,
  isQuizCompleted: () => false,
  isSetPrev: false,
  stepsToSkip: [],
  setStepsToSkip: () => null,
  stepsMap: {} as any,
  questionsMap: {} as any,
  stepsHistory: [],
};

export const formContextObj = React.createContext<TFormContext>(initialValue);

export const Provider = formContextObj.Provider;
